import React, { FC } from 'react';
import { Box, MenuItem, Tooltip, Typography } from '@mui/material';

export interface ProfileMenuItemProps {
	icon: React.ComponentType<{ className?: string }>;
	label: string;
	disabled?: boolean;
	onClick?: () => void;
	notificationTooltip?: string;
}

const ProfileMenuItem: FC<ProfileMenuItemProps> = ({ icon: Icon, label, onClick, disabled = false, notificationTooltip }) => {
	return (
		<MenuItem
			onClick={onClick}
			disabled={disabled}
			sx={{
				py: 1.5,
				px: 2,
				gap: 1.5,
				display: 'flex',
				alignItems: 'center'
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					'& svg': { width: 20, height: 20 } }}
				>
				<Icon className="" />
			</Box>

			<Typography variant="subtitle2" sx={{ flex: 1, textAlign: 'right' }}>
				{label}
			</Typography>

			{notificationTooltip && (
				<Tooltip title={notificationTooltip} placement="left">
					<Box
						sx={{
							width: 8,
							height: 8,
							borderRadius: '50%',
							backgroundColor: '#C77DFF',
							flexShrink: 0,
						}}
					/>
				</Tooltip>
			)}
		</MenuItem>
	);
};

export default ProfileMenuItem;

